import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util,$cookie} from "@util/util.js";

export default class ArrivalGoodsPCView extends BaseView {
    constructor(model) {
        super(model);
        this._model._view = this;

        // this._parentEl = this._model._parent._view._arrivalgoodsBoxEl;
        this._el = null;
        // 全局定时器
        this.timer = null;
    }

    render() {

        let firstChildDomain = document.domain.indexOf(".");
        let _domain = document.domain.substr(firstChildDomain+1);
        this._el = $(".subscribe_mask");       

        $('.subscribe_form').show();
        $('.subscribe_success').hide();
        $('div.subscribe_mask').show();
        // 重置验证码,清空错误提示,清空输入框的数据,重置定时器
        if(this.timer){
            clearInterval(this.timer);
        }
        $('.subscribe_validate .captcha_validate').attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
        $('.subscribe_content div:first-child input').val('');
        $('.subscribe_validate input').val('');
        $('.subscribe_verify input').val('');
        $('.error-container p').html('').parent().hide();
        $(".subscribe_verify .captcha_btn").css('pointer-events', 'unset');
        $(".subscribe_verify .captcha_btn").html("获取验证码"); 

        this.regEvent();
    }
    regEvent() {
        let that = this;
        let vcount = 0;
        let firstChildDomain = document.domain.indexOf(".");
        let _domain = document.domain.substr(firstChildDomain+1);

        // 点击到货通知事件
        // 点击文字验证
        that._el.off("click", ".subscribe_validate .captcha_validate").on("click", ".subscribe_validate .captcha_validate",function(e){
            $(this).attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
        });
        // 点击输入框叉号,清空手机号
        that._el.off("click", ".icon_clear").on("click", ".icon_clear",function(e){
            $('.subscribe_content div:first-child input').val('');
        });
        // 点击叉号
        that._el.off("click", ".close").on("click", ".close",function(e){
           $('.subscribe_mask').hide();
           $util.toggleBodyScroller(false);
           // 在这里清空输入框的值
           clearInterval(that.timer);
           $('.subscribe_content div:first-child input').val('');
           $('.subscribe_validate input').val('');
           $('.subscribe_verify input').val('');
        });
        //点击获取验证码按钮
        that._el.off("click", ".subscribe_verify .captcha_btn").on("click", ".subscribe_verify .captcha_btn",function(e){
            
            if($(this).html()=='重新发送') {
                vcount++;
                if(vcount == 1) {
                    $('.subscribe_validate input').val('');
                    $('.subscribe_validate .captcha_validate').attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
                }
                // console.log('count',vcount)
            }
            if ($('.subscribe_number input').val() == '') {
                $('.error-container p').html('手机号不能为空').parent().show();
                return false;
            } else {
                var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!reg.test($('.subscribe_number input').val())) {
                    $('.error-container p').html('手机号码格式不正确').parent().show();
                    return false;
                } else {
                    if($('.subscribe_validate input').val() == '') {
                        $('.error-container p').html('图形验证不能为空').parent().show();
                        return false;
                    } else {
                        $('.error-container p').html('').parent().hide();
                        var phone = $('.subscribe_number input').val();
                        var leID = $cookie.getCookie('leid');
                        var aurl = 'https://papi.'+_domain;
                        $.ajax({
                            url: aurl + '/stock/sendsms.jhtm',
                            type: "GET",
                            data: {
                                "mobile": phone,
                                "leId": leID,
                                "vcode": $('.subscribe_validate input').val()
                            },
                            dataType: "jsonp",
                            jsonp: "jsonpcallback",
                            jsonpCallback: 'jQueryJSONP_stock_sendsms',
                            timeout: 5000,
                            success: function (data) {
                                if (data && (data.success || data.resultCode == "0000")) {
                                    var countTime = 120;
                                    $(".subscribe_verify .captcha_btn").css('pointer-events', 'none');
                                    that.timer = setInterval(function () {
                                        countTime--;
                                        $(".subscribe_verify .captcha_btn").html("已发送" + countTime);
                                        if (countTime == 0) {
                                            clearInterval(that.timer);
                                            $(".subscribe_verify .captcha_btn").css('pointer-events', 'unset');
                                            $(".subscribe_verify .captcha_btn").html("重新发送");
                                        }
                                    }, 1000);
                                    
            
                                } else {
                                    Alert.showTip(data.resultMsg);
                                    $('.subscribe_validate input').val('');
                                    $('.subscribe_validate .captcha_validate').attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
                                }
                            },
                            error: function(e) {
                                if(e.statusText == "timeout") {
                                    Alert.showTip('接口调用超时'); 
                                }
                                 $('.subscribe_validate input').val('');
                                $('.subscribe_validate .captcha_validate').attr('src', 'https://captcha.'+_domain+'/img?ss=' + (new Date()).valueOf());
                            }
                        })
                    }
                }
            }
        });
        // 点击确认调到货通知接口
        that._el.off("click", ".submit").on("click", ".submit",function(e){
            // 校验非空和格式
            if ($('.subscribe_number input').val() == '') {
                $('.error-container p').html('手机号不能为空').parent().show();
                return false;
            } else {
                var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!reg.test($('.subscribe_number input').val())) {
                    $('.error-container p').html('手机号码格式不正确').parent().show();
                    return false;
                } else {
                    if($('.subscribe_validate input').val() == '') {
                        $('.error-container p').html('图形验证不能为空').parent().show();
                        return false;
                    } else if($('.subscribe_verify input').val() == '') {
                        $('.error-container p').html('短信验证不能为空').parent().show();
                        return false;
                    } else {
                        $('.error-container').hide();
                        var phone = $('.subscribe_number input').val();
                        var leID = '';
                        var leIDArr = document.cookie.split('; ');
                        for (var i = 0; i < leIDArr.length; i++) {
                            if (leIDArr[i].split('=')[0] == 'leid') {
                                leID = leIDArr[i].split('=')[1];
                            }
                        }
                        // let lenovoId = passport.cookie.lenovoId;
                        // let memberCode = passport.cookie.loginName;
                        if (that._model._parent._data._subscribe) {
                            var activetyType = 5;
                        } else if (that._model._parent._data._subscribeSnap) {
                            var activetyType = 3;
                        } else if (that._model._parent._data._kill) {
                            var activetyType = 2;
                        } else {
                            // 普通商品
                            var activetyType = 0;
                        }
                        var aurl = 'https://papi.'+_domain;
                        $.ajax({
                            type: 'GET',
                            url: aurl + '/stock/subscribe.jhtm',
                            data: {
                                activityType: activetyType, // 详情页活动类型：秒杀 2，预约抢购 3，秒杀倒计时 4， 预约 5
                                clientType: 'PC',
                                linkAddress: that._model._arrivalGoods[0].linkAddress,
                                phone: phone,
                                productCode: that._model._arrivalGoods[0].code,
                                productName: that._model._arrivalGoods[0].name,
                                smsCode: $('.subscribe_verify input').val(),
                                lenovoAccount: passport.cookie.loginName,    //'15575925447'
                                lenovoID: passport.cookie.lenovoId,        //10127832429
                                mallName: '联想官网',
                                leID: leID
                            },
                            dataType: "jsonp",
                            jsonp: "jsonpcallback",
                            jsonpCallback: 'jQueryJSONP_stock_subscribe',
                            timeout: 5000,
                            success: function (res) {
                                if(res.resultCode == '0000') {
                                    $('.subscribe_form').hide();
                                    $('.subscribe_success').show();
                                    // 在这里清空输入框的值
                                    $('.subscribe_content div:first-child input').val('');
                                    $('.subscribe_validate input').val('');
                                    $('.subscribe_verify input').val('');
                                    // 清除定时器
                                    clearInterval(that.timer);
                                    $(".subscribe_verify .captcha_btn").css('pointer-events', 'unset');
                                    $(".subscribe_verify .captcha_btn").html("重新发送");
                                } else if(res.resultCode == '20203') {
                                    $('.error-container p').html(res.resultMsg).parent().show();
                                } else {
                                    $('.error-container p').html(res.resultMsg).parent().show();
                                }
                            }
                        })
                    }
                }
            } 
        });
    }
}